module.exports = __webpack_public_path__ + "static/media/speach_ic.4101de72.svg";